import React from 'react';
import './Startbasic.css';

const startbasic = (props) => {
    return null;
}

export default startbasic;